import React, { useEffect, useState } from 'react'
import DATA from './plaintexts'
import TERMS from './terms'

import './termsBody.scss'

function TermsBody({ isMobile }) {
  const [terms, setTerms] = useState(isMobile ? DATA.mobile : DATA.desktop)

  useEffect(() => {
    setTerms(isMobile ? DATA.mobile : DATA.desktop)
  }, [isMobile])

  return (
    <div className="f-roulette-terms__body">
      <div className="f-roulette-terms__body__header">
        <h4>
          <b>{terms.title}</b>
          {isMobile ? (
            <p>
              <b>{terms.subtitle}</b>
            </p>
          ) : null}
        </h4>
      </div>
      <div className="f-roulette-terms__body__content">
        {isMobile ? (
          <div>
            <p>{terms.initial_plain}</p>
            <p>
              <b>{terms.bold_text}</b>
              {terms.final_text}
            </p>
            <p>{terms.footer_text}</p>{' '}
          </div>
        ) : (
          <p>
            {terms.initial_plain} <b>{terms.bold_text}</b>
            {terms.final_text}
          </p>
        )}
        <hr />
        {TERMS &&
          TERMS.terms.map((item, index) => (
            <div>
              <div key={index}>
                <div className="f-roulette-terms__body__content__text__num">
                  {item.num}
                  {'. '}
                </div>
                <div className="f-roulette-terms__body__content__text">
                  {item.cont}
                </div>
              </div>
              <hr />
            </div>
          ))}
        <div className="f-roulette-terms__body__content__text">
        En caso de tener dudas, o si quieres recibir mayor información, 
        comunícate con la línea de servicio y atención al cliente en Paraguay: 021 6570000
        </div>
      </div>
    </div>
  )
}

export default TermsBody
